import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import Description from '../../ReadyBuilder/Description';

interface Props {
  description: string;
  onDescriptionChange: (value: string) => void;
}

function ProductCollectionDescription({ description, onDescriptionChange }: Props) {
  return (
    <Description
      description={description}
      onDescriptionChange={onDescriptionChange}
      emptyStateText={just('Add a section description')}
      placeholder={just('Enter product collection description...')}
      intercomTarget={just('builder-v2-section-description-field')}
    />
  );
}

export default observer(ProductCollectionDescription);
